<template>
    <div class="form__group">
        <multiselect
            :options="results"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="eventName"
            track-by="id"
            :searchable="true"
            :loading="loading"
            :internal-search="false"
            :multiple="multiple"
            :options-limit="10"
            :show-labels="false"
            @search-change="onSearchChange"
            v-model="selected"
            :class="{
                'form__control': true,
                'form__control--invalid': errors.first(this.name)
            }"
        >
            <span slot="noOptions">Type to search events...</span>
        </multiselect>
        <label class="form__label">{{ label }}</label>
        <a
            href="#"
            @click.prevent.stop="clearValue"
            class="form__clear"
            v-if="allowEmpty && selected"
        >
            Clear
        </a>
        <div class="form__validation" slot="validation">
            {{ errors.first(this.name) }}
        </div>
    </div>
</template>

<script>
import API from '@api';
import AjaxSelect from './AjaxSelect';

export default {
    name: 'FormControlEvent',
    mixins: [AjaxSelect],
    props: {
        label: {
            type: String,
            default: 'Related Event',
        },
        placeholder: {
            type: String,
            default: 'Select an event...',
        },
    },
    methods: {
        async search(query) {
            try {
                this.results = await API.searchEvents({query});
            } catch(error) {
                console.warn(error);
            } finally {
                this.loading = false;
            }
        },
        getItemFromCache(id) {
            return this.$store.getters['selectCache/getEvent'](id);
        },
        addItemToCache(event) {
            this.$store.commit('selectCache/addEvent', event);
        },
        reset() {
            this.selected = null;
        }
    },
    mounted() {
        this.search('');
        this.setInitialValue();
    },
}
</script>

